import axios from "axios";

// TODO 로젠 API
export const LogenInstance = axios.create({
  baseURL: `${process.env.REACT_APP_LOGEN_API_URL}/AndyLogen`,
});

LogenInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 로젠 API
export const LogenTestInstance = axios.create({
  baseURL: `${process.env.REACT_APP_TEST_API_URL}/AndyLogen`,
});

LogenTestInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 롯데 API
export const LotteInstance = axios.create({
  baseURL: `${process.env.REACT_APP_LOTTE_API_URL}/AndyLotte`,
});

LotteInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 한진 API
export const HanjinInstance = axios.create({
  baseURL: `${process.env.REACT_APP_HANJIN_API_URL}/AndyHanjin`,
});

HanjinInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 한덱스 API
export const HandexInstance = axios.create({
  baseURL: `${process.env.REACT_APP_HANDEX_API_URL}/AndyHandex`,
});

HandexInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// KPC 고객 웹은 서버가 발급한 HttpOnly 세션 쿠키로 인증한다.
export const KpcInstance = axios.create({
  baseURL: process.env.REACT_APP_KPC_API_URL,
  withCredentials: true,
});

let isKpcSessionExpiryHandling = false;

KpcInstance.interceptors.response.use(
  (response) => {
    // 정상 로그인 또는 정상 API 응답 뒤에는 다음 만료 감지를 다시 허용한다.
    isKpcSessionExpiryHandling = false;
    return response.data;
  },
  (error) => {
    const requestUrl = error.config?.url || "";
    const isLoginRequest = requestUrl.includes("/watcher/sign");

    // 로그인 실패는 비밀번호 오류일 수 있으므로 강제 로그아웃 대상에서 제외한다.
    if (
      error.response?.status === 401 &&
      !isLoginRequest &&
      !isKpcSessionExpiryHandling
    ) {
      isKpcSessionExpiryHandling = true;
      // 첫 화면 요청은 React 이벤트 리스너가 등록되기 전에 401이 발생할 수 있다.
      // 세션 표식을 남긴 뒤 로그인 화면을 새로 열어 만료 처리를 확실하게 수행한다.
      window.sessionStorage.setItem("kpc-session-expired", "true");
      window.location.replace("/");
    }

    return Promise.reject(error);
  },
);

// TODO 동영상 전용 API
export const videoInstance = axios.create({
  baseURL: `${process.env.REACT_APP_VIDEO_API_URL}`,
});

videoInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);
